var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-urgent"},[_c('div',{staticClass:"content"},[_vm._v(" 系统公告：尊贵的用户您好，现系统升级体验， 将于 北京时间2022/08/29 周一 13：00 ~14：00 PM进行全平台维护，届时给您带来的不便 ， 敬请谅解~ 致谢 ！ ")])])
}]

export { render, staticRenderFns }